/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AggregationsRequest,
  AggregationsResponse,
  AvailableConnectorTypesResponse,
  ConnectorConfigCreate,
  ConnectorConfigListResponse,
  ConnectorConfigResponse,
  ConnectorConfigUpdate,
  ConnectorStatisticsResponse,
  EstimateCostRequest,
  EstimateCostResponse,
  GetCompanyNetworkApiConnectorsPersonsCompanyNetworkPost200,
  GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams,
  HTTPValidationError,
  ListConnectorConfigurationsApiConnectorsConfigurationsGetParams,
  ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet200Item,
  ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams,
  ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet200Item,
  ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams,
  ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet200Item,
  ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams,
  ListGreenhouseJobsApiConnectorsGreenhouseJobsGet200Item,
  ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams,
  ListPdlPersonsApiConnectorsPdlPersonsGetParams,
  ListSyncRunsApiConnectorsSyncRunsGetParams,
  PDLPersonListResponse,
  PDLPersonResponse,
  SrcApiSchemasConnectorSchemasCareerTransitionRequest,
  SrcApiSchemasConnectorSchemasCompanyNetworkRequest,
  SrcApiSchemasConnectorSchemasPersonSearchRequest,
  SrcApiSchemasConnectorSchemasPersonSearchResponse,
  SrcApiSchemasConnectorSchemasPersonSearchResult,
  SrcApiSchemasConnectorSchemasSkillSearchRequest,
  SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost200,
  SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody,
  SyncRunListResponse,
  SyncRunResponse,
  TelemetryListResponse,
  TestConnectionRequest,
  TestConnectionResponse,
  TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPost200,
  TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody,
  TriggerSyncRequest,
  ValidateConfigRequest,
  ValidateConfigResponse
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Get all available connector types with their metadata.

Returns complete enum values and connector information.
Requires connections:read permission.
 * @summary Get Available Connector Types
 */
export const getAvailableConnectorTypesApiConnectorsTypesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AvailableConnectorTypesResponse>(
      {url: `/api/connectors/types`, method: 'GET', signal
    },
      );
    }
  



export const getGetAvailableConnectorTypesApiConnectorsTypesGetQueryKey = () => {
    return [
    `/api/connectors/types`
    ] as const;
    }

    
export const getGetAvailableConnectorTypesApiConnectorsTypesGetQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableConnectorTypesApiConnectorsTypesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>> = ({ signal }) => getAvailableConnectorTypesApiConnectorsTypesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAvailableConnectorTypesApiConnectorsTypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>>
export type GetAvailableConnectorTypesApiConnectorsTypesGetQueryError = unknown


export function useGetAvailableConnectorTypesApiConnectorsTypesGet<TData = Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableConnectorTypesApiConnectorsTypesGet<TData = Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>,
          TError,
          Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableConnectorTypesApiConnectorsTypesGet<TData = Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Available Connector Types
 */

export function useGetAvailableConnectorTypesApiConnectorsTypesGet<TData = Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableConnectorTypesApiConnectorsTypesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAvailableConnectorTypesApiConnectorsTypesGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Return the Google OAuth callback URI to register for BigQuery connectors.
 * @summary Get Bigquery Oauth Callback Uri
 */
export const getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/connectors/bigquery/oauth/callback-uri`, method: 'GET', signal
    },
      );
    }
  



export const getGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryKey = () => {
    return [
    `/api/connectors/bigquery/oauth/callback-uri`
    ] as const;
    }

    
export const getGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryOptions = <TData = Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>> = ({ signal }) => getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>>
export type GetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryError = unknown


export function useGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet<TData = Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>,
          TError,
          Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet<TData = Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>,
          TError,
          Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet<TData = Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Bigquery Oauth Callback Uri
 */

export function useGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet<TData = Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBigqueryOauthCallbackUriApiConnectorsBigqueryOauthCallbackUriGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create new connector configuration.

Admin-only endpoint.

Steps:
1. Validate connector type and configuration
2. Test connection with provided credentials
3. Estimate record count and check cost threshold
4. Encrypt credentials
5. Save to database

Returns:
    Created connector configuration
 * @summary Create Connector Configuration
 */
export const createConnectorConfigurationApiConnectorsConfigurationsPost = (
    connectorConfigCreate: ConnectorConfigCreate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectorConfigResponse>(
      {url: `/api/connectors/configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectorConfigCreate, signal
    },
      );
    }
  


export const getCreateConnectorConfigurationApiConnectorsConfigurationsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>, TError,{data: ConnectorConfigCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>, TError,{data: ConnectorConfigCreate}, TContext> => {

const mutationKey = ['createConnectorConfigurationApiConnectorsConfigurationsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>, {data: ConnectorConfigCreate}> = (props) => {
          const {data} = props ?? {};

          return  createConnectorConfigurationApiConnectorsConfigurationsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConnectorConfigurationApiConnectorsConfigurationsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>>
    export type CreateConnectorConfigurationApiConnectorsConfigurationsPostMutationBody = ConnectorConfigCreate
    export type CreateConnectorConfigurationApiConnectorsConfigurationsPostMutationError = HTTPValidationError

    /**
 * @summary Create Connector Configuration
 */
export const useCreateConnectorConfigurationApiConnectorsConfigurationsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>, TError,{data: ConnectorConfigCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConnectorConfigurationApiConnectorsConfigurationsPost>>,
        TError,
        {data: ConnectorConfigCreate},
        TContext
      > => {

      const mutationOptions = getCreateConnectorConfigurationApiConnectorsConfigurationsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List all connector configurations for the customer.

Admin-only endpoint.
 * @summary List Connector Configurations
 */
export const listConnectorConfigurationsApiConnectorsConfigurationsGet = (
    params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectorConfigListResponse>(
      {url: `/api/connectors/configurations`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListConnectorConfigurationsApiConnectorsConfigurationsGetQueryKey = (params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams,) => {
    return [
    `/api/connectors/configurations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListConnectorConfigurationsApiConnectorsConfigurationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError = HTTPValidationError>(params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectorConfigurationsApiConnectorsConfigurationsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>> = ({ signal }) => listConnectorConfigurationsApiConnectorsConfigurationsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListConnectorConfigurationsApiConnectorsConfigurationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>>
export type ListConnectorConfigurationsApiConnectorsConfigurationsGetQueryError = HTTPValidationError


export function useListConnectorConfigurationsApiConnectorsConfigurationsGet<TData = Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListConnectorConfigurationsApiConnectorsConfigurationsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListConnectorConfigurationsApiConnectorsConfigurationsGet<TData = Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListConnectorConfigurationsApiConnectorsConfigurationsGet<TData = Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Connector Configurations
 */

export function useListConnectorConfigurationsApiConnectorsConfigurationsGet<TData = Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListConnectorConfigurationsApiConnectorsConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectorConfigurationsApiConnectorsConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListConnectorConfigurationsApiConnectorsConfigurationsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get single connector configuration by ID.

Admin-only endpoint.
 * @summary Get Connector Configuration
 */
export const getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet = (
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectorConfigResponse>(
      {url: `/api/connectors/configurations/${connectorId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryKey = (connectorId?: string,) => {
    return [
    `/api/connectors/configurations/${connectorId}`
    ] as const;
    }

    
export const getGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError = HTTPValidationError>(connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryKey(connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>> = ({ signal }) => getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet(connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>>
export type GetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryError = HTTPValidationError


export function useGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet<TData = Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError = HTTPValidationError>(
 connectorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet<TData = Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet<TData = Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Connector Configuration
 */

export function useGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet<TData = Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorConfigurationApiConnectorsConfigurationsConnectorIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConnectorConfigurationApiConnectorsConfigurationsConnectorIdGetQueryOptions(connectorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update connector configuration.

Admin-only endpoint.

If sync_config is updated:
- Configuration is versioned
- Old config saved to history
- Connection tested with new config
 * @summary Update Connector Configuration
 */
export const updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut = (
    connectorId: string,
    connectorConfigUpdate: ConnectorConfigUpdate,
 ) => {
      
      
      return customInstance<ConnectorConfigResponse>(
      {url: `/api/connectors/configurations/${connectorId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: connectorConfigUpdate
    },
      );
    }
  


export const getUpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>, TError,{connectorId: string;data: ConnectorConfigUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>, TError,{connectorId: string;data: ConnectorConfigUpdate}, TContext> => {

const mutationKey = ['updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>, {connectorId: string;data: ConnectorConfigUpdate}> = (props) => {
          const {connectorId,data} = props ?? {};

          return  updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut(connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>>
    export type UpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPutMutationBody = ConnectorConfigUpdate
    export type UpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPutMutationError = HTTPValidationError

    /**
 * @summary Update Connector Configuration
 */
export const useUpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>, TError,{connectorId: string;data: ConnectorConfigUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPut>>,
        TError,
        {connectorId: string;data: ConnectorConfigUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateConnectorConfigurationApiConnectorsConfigurationsConnectorIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete (disable) connector configuration.

Admin-only endpoint.

Soft delete: marks as disabled, preserves sync history.
 * @summary Delete Connector Configuration
 */
export const deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete = (
    connectorId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/connectors/configurations/${connectorId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>, TError,{connectorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>, TError,{connectorId: string}, TContext> => {

const mutationKey = ['deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>, {connectorId: string}> = (props) => {
          const {connectorId} = props ?? {};

          return  deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete(connectorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>>
    
    export type DeleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Connector Configuration
 */
export const useDeleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>, TError,{connectorId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDelete>>,
        TError,
        {connectorId: string},
        TContext
      > => {

      const mutationOptions = getDeleteConnectorConfigurationApiConnectorsConfigurationsConnectorIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get preview data for a connector.

For filesystem connectors: Returns list of files in the directory
For PDL/API connectors: Returns sample data from the query

Admin-only endpoint.
 * @summary Get Connector Preview
 */
export const getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet = (
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/connectors/configurations/${connectorId}/preview`, method: 'GET', signal
    },
      );
    }
  



export const getGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryKey = (connectorId?: string,) => {
    return [
    `/api/connectors/configurations/${connectorId}/preview`
    ] as const;
    }

    
export const getGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError = HTTPValidationError>(connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryKey(connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>> = ({ signal }) => getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet(connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>>
export type GetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryError = HTTPValidationError


export function useGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet<TData = Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError = HTTPValidationError>(
 connectorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet<TData = Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet<TData = Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Connector Preview
 */

export function useGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet<TData = Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConnectorPreviewApiConnectorsConfigurationsConnectorIdPreviewGetQueryOptions(connectorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Trigger a manual connector sync.

Admin-only endpoint.

Returns immediately with sync run record.
Sync executes asynchronously via Celery task.

Check sync status via GET /sync-runs/{sync_id}
 * @summary Trigger Connector Sync
 */
export const triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost = (
    connectorId: string,
    triggerSyncRequest: TriggerSyncRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SyncRunResponse>(
      {url: `/api/connectors/configurations/${connectorId}/trigger-sync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: triggerSyncRequest, signal
    },
      );
    }
  


export const getTriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>, TError,{connectorId: string;data: TriggerSyncRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>, TError,{connectorId: string;data: TriggerSyncRequest}, TContext> => {

const mutationKey = ['triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>, {connectorId: string;data: TriggerSyncRequest}> = (props) => {
          const {connectorId,data} = props ?? {};

          return  triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost(connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPostMutationResult = NonNullable<Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>>
    export type TriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPostMutationBody = TriggerSyncRequest
    export type TriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPostMutationError = HTTPValidationError

    /**
 * @summary Trigger Connector Sync
 */
export const useTriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>, TError,{connectorId: string;data: TriggerSyncRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPost>>,
        TError,
        {connectorId: string;data: TriggerSyncRequest},
        TContext
      > => {

      const mutationOptions = getTriggerConnectorSyncApiConnectorsConfigurationsConnectorIdTriggerSyncPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List sync runs for the customer.

Admin-only endpoint.

Supports filtering and pagination.
 * @summary List Sync Runs
 */
export const listSyncRunsApiConnectorsSyncRunsGet = (
    params?: ListSyncRunsApiConnectorsSyncRunsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SyncRunListResponse>(
      {url: `/api/connectors/sync-runs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListSyncRunsApiConnectorsSyncRunsGetQueryKey = (params?: ListSyncRunsApiConnectorsSyncRunsGetParams,) => {
    return [
    `/api/connectors/sync-runs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSyncRunsApiConnectorsSyncRunsGetQueryOptions = <TData = Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError = HTTPValidationError>(params?: ListSyncRunsApiConnectorsSyncRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncRunsApiConnectorsSyncRunsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>> = ({ signal }) => listSyncRunsApiConnectorsSyncRunsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListSyncRunsApiConnectorsSyncRunsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>>
export type ListSyncRunsApiConnectorsSyncRunsGetQueryError = HTTPValidationError


export function useListSyncRunsApiConnectorsSyncRunsGet<TData = Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListSyncRunsApiConnectorsSyncRunsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListSyncRunsApiConnectorsSyncRunsGet<TData = Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError = HTTPValidationError>(
 params?: ListSyncRunsApiConnectorsSyncRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListSyncRunsApiConnectorsSyncRunsGet<TData = Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError = HTTPValidationError>(
 params?: ListSyncRunsApiConnectorsSyncRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Sync Runs
 */

export function useListSyncRunsApiConnectorsSyncRunsGet<TData = Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError = HTTPValidationError>(
 params?: ListSyncRunsApiConnectorsSyncRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSyncRunsApiConnectorsSyncRunsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListSyncRunsApiConnectorsSyncRunsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get sync run details by ID.

Admin-only endpoint.
 * @summary Get Sync Run
 */
export const getSyncRunApiConnectorsSyncRunsSyncIdGet = (
    syncId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SyncRunResponse>(
      {url: `/api/connectors/sync-runs/${syncId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetSyncRunApiConnectorsSyncRunsSyncIdGetQueryKey = (syncId?: string,) => {
    return [
    `/api/connectors/sync-runs/${syncId}`
    ] as const;
    }

    
export const getGetSyncRunApiConnectorsSyncRunsSyncIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError = HTTPValidationError>(syncId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncRunApiConnectorsSyncRunsSyncIdGetQueryKey(syncId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>> = ({ signal }) => getSyncRunApiConnectorsSyncRunsSyncIdGet(syncId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(syncId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSyncRunApiConnectorsSyncRunsSyncIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>>
export type GetSyncRunApiConnectorsSyncRunsSyncIdGetQueryError = HTTPValidationError


export function useGetSyncRunApiConnectorsSyncRunsSyncIdGet<TData = Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError = HTTPValidationError>(
 syncId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSyncRunApiConnectorsSyncRunsSyncIdGet<TData = Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError = HTTPValidationError>(
 syncId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSyncRunApiConnectorsSyncRunsSyncIdGet<TData = Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError = HTTPValidationError>(
 syncId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Sync Run
 */

export function useGetSyncRunApiConnectorsSyncRunsSyncIdGet<TData = Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError = HTTPValidationError>(
 syncId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncRunApiConnectorsSyncRunsSyncIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSyncRunApiConnectorsSyncRunsSyncIdGetQueryOptions(syncId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get telemetry events for a sync run.

Admin-only endpoint.

Used for real-time progress monitoring.
 * @summary Get Sync Telemetry
 */
export const getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet = (
    syncId: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelemetryListResponse>(
      {url: `/api/connectors/sync-runs/${syncId}/telemetry`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryKey = (syncId?: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams,) => {
    return [
    `/api/connectors/sync-runs/${syncId}/telemetry`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryOptions = <TData = Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError = HTTPValidationError>(syncId: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryKey(syncId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>> = ({ signal }) => getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet(syncId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(syncId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>>
export type GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryError = HTTPValidationError


export function useGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet<TData = Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError = HTTPValidationError>(
 syncId: string,
    params: undefined |  GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>,
          TError,
          Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet<TData = Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError = HTTPValidationError>(
 syncId: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>,
          TError,
          Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet<TData = Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError = HTTPValidationError>(
 syncId: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Sync Telemetry
 */

export function useGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet<TData = Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError = HTTPValidationError>(
 syncId: string,
    params?: GetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSyncTelemetryApiConnectorsSyncRunsSyncIdTelemetryGetQueryOptions(syncId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Validate connector configuration without saving.

Admin-only endpoint.

Used by frontend to validate before submission.
 * @summary Validate Configuration
 */
export const validateConfigurationApiConnectorsValidateConfigPost = (
    validateConfigRequest: ValidateConfigRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateConfigResponse>(
      {url: `/api/connectors/validate-config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateConfigRequest, signal
    },
      );
    }
  


export const getValidateConfigurationApiConnectorsValidateConfigPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>, TError,{data: ValidateConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>, TError,{data: ValidateConfigRequest}, TContext> => {

const mutationKey = ['validateConfigurationApiConnectorsValidateConfigPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>, {data: ValidateConfigRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateConfigurationApiConnectorsValidateConfigPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateConfigurationApiConnectorsValidateConfigPostMutationResult = NonNullable<Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>>
    export type ValidateConfigurationApiConnectorsValidateConfigPostMutationBody = ValidateConfigRequest
    export type ValidateConfigurationApiConnectorsValidateConfigPostMutationError = HTTPValidationError

    /**
 * @summary Validate Configuration
 */
export const useValidateConfigurationApiConnectorsValidateConfigPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>, TError,{data: ValidateConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateConfigurationApiConnectorsValidateConfigPost>>,
        TError,
        {data: ValidateConfigRequest},
        TContext
      > => {

      const mutationOptions = getValidateConfigurationApiConnectorsValidateConfigPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Fetch the schema for a specific connector (primarily for BigQuery/Structured Data).
Returns a hierarchical view of datasets, tables, and columns.
 * @summary Get connector schema (datasets, tables, columns)
 */
export const getConnectorSchemaApiConnectorsConnectorIdSchemaGet = (
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/connectors/${connectorId}/schema`, method: 'GET', signal
    },
      );
    }
  



export const getGetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryKey = (connectorId?: string,) => {
    return [
    `/api/connectors/${connectorId}/schema`
    ] as const;
    }

    
export const getGetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError = HTTPValidationError>(connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryKey(connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>> = ({ signal }) => getConnectorSchemaApiConnectorsConnectorIdSchemaGet(connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>>
export type GetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryError = HTTPValidationError


export function useGetConnectorSchemaApiConnectorsConnectorIdSchemaGet<TData = Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError = HTTPValidationError>(
 connectorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorSchemaApiConnectorsConnectorIdSchemaGet<TData = Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorSchemaApiConnectorsConnectorIdSchemaGet<TData = Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get connector schema (datasets, tables, columns)
 */

export function useGetConnectorSchemaApiConnectorsConnectorIdSchemaGet<TData = Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorSchemaApiConnectorsConnectorIdSchemaGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConnectorSchemaApiConnectorsConnectorIdSchemaGetQueryOptions(connectorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Test connector connection with provided credentials.

Admin-only endpoint.

Does NOT save configuration - only tests connectivity.
 * @summary Test Connection
 */
export const testConnectionApiConnectorsTestConnectionPost = (
    testConnectionRequest: TestConnectionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TestConnectionResponse>(
      {url: `/api/connectors/test-connection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testConnectionRequest, signal
    },
      );
    }
  


export const getTestConnectionApiConnectorsTestConnectionPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext> => {

const mutationKey = ['testConnectionApiConnectorsTestConnectionPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>, {data: TestConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  testConnectionApiConnectorsTestConnectionPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestConnectionApiConnectorsTestConnectionPostMutationResult = NonNullable<Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>>
    export type TestConnectionApiConnectorsTestConnectionPostMutationBody = TestConnectionRequest
    export type TestConnectionApiConnectorsTestConnectionPostMutationError = HTTPValidationError

    /**
 * @summary Test Connection
 */
export const useTestConnectionApiConnectorsTestConnectionPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testConnectionApiConnectorsTestConnectionPost>>,
        TError,
        {data: TestConnectionRequest},
        TContext
      > => {

      const mutationOptions = getTestConnectionApiConnectorsTestConnectionPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Estimate cost for a connector sync.

Admin-only endpoint.

Returns:
- Estimated record count (via connector's estimate method)
- Estimated cost based on settings.connector_cost_per_record
- Whether cost acknowledgment is required
 * @summary Estimate Sync Cost
 */
export const estimateSyncCostApiConnectorsEstimateCostPost = (
    estimateCostRequest: EstimateCostRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EstimateCostResponse>(
      {url: `/api/connectors/estimate-cost`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estimateCostRequest, signal
    },
      );
    }
  


export const getEstimateSyncCostApiConnectorsEstimateCostPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>, TError,{data: EstimateCostRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>, TError,{data: EstimateCostRequest}, TContext> => {

const mutationKey = ['estimateSyncCostApiConnectorsEstimateCostPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>, {data: EstimateCostRequest}> = (props) => {
          const {data} = props ?? {};

          return  estimateSyncCostApiConnectorsEstimateCostPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EstimateSyncCostApiConnectorsEstimateCostPostMutationResult = NonNullable<Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>>
    export type EstimateSyncCostApiConnectorsEstimateCostPostMutationBody = EstimateCostRequest
    export type EstimateSyncCostApiConnectorsEstimateCostPostMutationError = HTTPValidationError

    /**
 * @summary Estimate Sync Cost
 */
export const useEstimateSyncCostApiConnectorsEstimateCostPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>, TError,{data: EstimateCostRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof estimateSyncCostApiConnectorsEstimateCostPost>>,
        TError,
        {data: EstimateCostRequest},
        TContext
      > => {

      const mutationOptions = getEstimateSyncCostApiConnectorsEstimateCostPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List PDL person records for the customer.

Accessible to users with connections:read permission.

Supports search and filtering.
 * @summary List Pdl Persons
 */
export const listPdlPersonsApiConnectorsPdlPersonsGet = (
    params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PDLPersonListResponse>(
      {url: `/api/connectors/pdl-persons`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListPdlPersonsApiConnectorsPdlPersonsGetQueryKey = (params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams,) => {
    return [
    `/api/connectors/pdl-persons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListPdlPersonsApiConnectorsPdlPersonsGetQueryOptions = <TData = Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError = HTTPValidationError>(params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPdlPersonsApiConnectorsPdlPersonsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>> = ({ signal }) => listPdlPersonsApiConnectorsPdlPersonsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListPdlPersonsApiConnectorsPdlPersonsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>>
export type ListPdlPersonsApiConnectorsPdlPersonsGetQueryError = HTTPValidationError


export function useListPdlPersonsApiConnectorsPdlPersonsGet<TData = Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListPdlPersonsApiConnectorsPdlPersonsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>,
          TError,
          Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListPdlPersonsApiConnectorsPdlPersonsGet<TData = Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError = HTTPValidationError>(
 params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>,
          TError,
          Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListPdlPersonsApiConnectorsPdlPersonsGet<TData = Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError = HTTPValidationError>(
 params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Pdl Persons
 */

export function useListPdlPersonsApiConnectorsPdlPersonsGet<TData = Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError = HTTPValidationError>(
 params?: ListPdlPersonsApiConnectorsPdlPersonsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPdlPersonsApiConnectorsPdlPersonsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListPdlPersonsApiConnectorsPdlPersonsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get single PDL person record by ID.

Admin-only endpoint.
 * @summary Get Pdl Person
 */
export const getPdlPersonApiConnectorsPdlPersonsPersonIdGet = (
    personId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PDLPersonResponse>(
      {url: `/api/connectors/pdl-persons/${personId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryKey = (personId?: number,) => {
    return [
    `/api/connectors/pdl-persons/${personId}`
    ] as const;
    }

    
export const getGetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError = HTTPValidationError>(personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryKey(personId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>> = ({ signal }) => getPdlPersonApiConnectorsPdlPersonsPersonIdGet(personId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(personId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>>
export type GetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryError = HTTPValidationError


export function useGetPdlPersonApiConnectorsPdlPersonsPersonIdGet<TData = Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError = HTTPValidationError>(
 personId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>,
          TError,
          Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPdlPersonApiConnectorsPdlPersonsPersonIdGet<TData = Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError = HTTPValidationError>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>,
          TError,
          Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPdlPersonApiConnectorsPdlPersonsPersonIdGet<TData = Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError = HTTPValidationError>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Pdl Person
 */

export function useGetPdlPersonApiConnectorsPdlPersonsPersonIdGet<TData = Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError = HTTPValidationError>(
 personId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPdlPersonApiConnectorsPdlPersonsPersonIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPdlPersonApiConnectorsPdlPersonsPersonIdGetQueryOptions(personId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get statistics for a connector.

Admin-only endpoint.

Returns aggregate metrics across all syncs.
 * @summary Get Connector Statistics
 */
export const getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet = (
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectorStatisticsResponse>(
      {url: `/api/connectors/configurations/${connectorId}/statistics`, method: 'GET', signal
    },
      );
    }
  



export const getGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryKey = (connectorId?: string,) => {
    return [
    `/api/connectors/configurations/${connectorId}/statistics`
    ] as const;
    }

    
export const getGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError = HTTPValidationError>(connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryKey(connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>> = ({ signal }) => getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet(connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>>
export type GetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryError = HTTPValidationError


export function useGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet<TData = Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError = HTTPValidationError>(
 connectorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet<TData = Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet<TData = Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Connector Statistics
 */

export function useGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet<TData = Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError = HTTPValidationError>(
 connectorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConnectorStatisticsApiConnectorsConfigurationsConnectorIdStatisticsGetQueryOptions(connectorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Search persons with text query and filters. Uses Elasticsearch if available, falls back to PostgreSQL.
 * @summary Search for persons
 */
export const searchPersonsApiConnectorsPersonsSearchPost = (
    srcApiSchemasConnectorSchemasPersonSearchRequest: SrcApiSchemasConnectorSchemasPersonSearchRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasConnectorSchemasPersonSearchResponse>(
      {url: `/api/connectors/persons/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: srcApiSchemasConnectorSchemasPersonSearchRequest, signal
    },
      );
    }
  


export const getSearchPersonsApiConnectorsPersonsSearchPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>, TError,{data: SrcApiSchemasConnectorSchemasPersonSearchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>, TError,{data: SrcApiSchemasConnectorSchemasPersonSearchRequest}, TContext> => {

const mutationKey = ['searchPersonsApiConnectorsPersonsSearchPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>, {data: SrcApiSchemasConnectorSchemasPersonSearchRequest}> = (props) => {
          const {data} = props ?? {};

          return  searchPersonsApiConnectorsPersonsSearchPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchPersonsApiConnectorsPersonsSearchPostMutationResult = NonNullable<Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>>
    export type SearchPersonsApiConnectorsPersonsSearchPostMutationBody = SrcApiSchemasConnectorSchemasPersonSearchRequest
    export type SearchPersonsApiConnectorsPersonsSearchPostMutationError = HTTPValidationError

    /**
 * @summary Search for persons
 */
export const useSearchPersonsApiConnectorsPersonsSearchPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>, TError,{data: SrcApiSchemasConnectorSchemasPersonSearchRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchPersonsApiConnectorsPersonsSearchPost>>,
        TError,
        {data: SrcApiSchemasConnectorSchemasPersonSearchRequest},
        TContext
      > => {

      const mutationOptions = getSearchPersonsApiConnectorsPersonsSearchPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve a single person by their PDL ID.
 * @summary Get person by ID
 */
export const getPersonByIdApiConnectorsPersonsPdlIdGet = (
    pdlId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasConnectorSchemasPersonSearchResult>(
      {url: `/api/connectors/persons/${pdlId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPersonByIdApiConnectorsPersonsPdlIdGetQueryKey = (pdlId?: string,) => {
    return [
    `/api/connectors/persons/${pdlId}`
    ] as const;
    }

    
export const getGetPersonByIdApiConnectorsPersonsPdlIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError = HTTPValidationError>(pdlId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonByIdApiConnectorsPersonsPdlIdGetQueryKey(pdlId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>> = ({ signal }) => getPersonByIdApiConnectorsPersonsPdlIdGet(pdlId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(pdlId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPersonByIdApiConnectorsPersonsPdlIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>>
export type GetPersonByIdApiConnectorsPersonsPdlIdGetQueryError = HTTPValidationError


export function useGetPersonByIdApiConnectorsPersonsPdlIdGet<TData = Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError = HTTPValidationError>(
 pdlId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>,
          TError,
          Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPersonByIdApiConnectorsPersonsPdlIdGet<TData = Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError = HTTPValidationError>(
 pdlId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>,
          TError,
          Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPersonByIdApiConnectorsPersonsPdlIdGet<TData = Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError = HTTPValidationError>(
 pdlId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get person by ID
 */

export function useGetPersonByIdApiConnectorsPersonsPdlIdGet<TData = Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError = HTTPValidationError>(
 pdlId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonByIdApiConnectorsPersonsPdlIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPersonByIdApiConnectorsPersonsPdlIdGetQueryOptions(pdlId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Find people who moved from one company to another. Uses Neo4j for relationship queries.
 * @summary Find career transitions
 */
export const findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost = (
    srcApiSchemasConnectorSchemasCareerTransitionRequest: SrcApiSchemasConnectorSchemasCareerTransitionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasConnectorSchemasPersonSearchResult[]>(
      {url: `/api/connectors/persons/career-transitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: srcApiSchemasConnectorSchemasCareerTransitionRequest, signal
    },
      );
    }
  


export const getFindCareerTransitionsApiConnectorsPersonsCareerTransitionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>, TError,{data: SrcApiSchemasConnectorSchemasCareerTransitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>, TError,{data: SrcApiSchemasConnectorSchemasCareerTransitionRequest}, TContext> => {

const mutationKey = ['findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>, {data: SrcApiSchemasConnectorSchemasCareerTransitionRequest}> = (props) => {
          const {data} = props ?? {};

          return  findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FindCareerTransitionsApiConnectorsPersonsCareerTransitionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>>
    export type FindCareerTransitionsApiConnectorsPersonsCareerTransitionsPostMutationBody = SrcApiSchemasConnectorSchemasCareerTransitionRequest
    export type FindCareerTransitionsApiConnectorsPersonsCareerTransitionsPostMutationError = HTTPValidationError

    /**
 * @summary Find career transitions
 */
export const useFindCareerTransitionsApiConnectorsPersonsCareerTransitionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>, TError,{data: SrcApiSchemasConnectorSchemasCareerTransitionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof findCareerTransitionsApiConnectorsPersonsCareerTransitionsPost>>,
        TError,
        {data: SrcApiSchemasConnectorSchemasCareerTransitionRequest},
        TContext
      > => {

      const mutationOptions = getFindCareerTransitionsApiConnectorsPersonsCareerTransitionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Find people with specific skill combinations. Uses Neo4j for skill relationship queries.
 * @summary Search by skills
 */
export const searchBySkillsApiConnectorsPersonsBySkillsPost = (
    srcApiSchemasConnectorSchemasSkillSearchRequest: SrcApiSchemasConnectorSchemasSkillSearchRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasConnectorSchemasPersonSearchResult[]>(
      {url: `/api/connectors/persons/by-skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: srcApiSchemasConnectorSchemasSkillSearchRequest, signal
    },
      );
    }
  


export const getSearchBySkillsApiConnectorsPersonsBySkillsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>, TError,{data: SrcApiSchemasConnectorSchemasSkillSearchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>, TError,{data: SrcApiSchemasConnectorSchemasSkillSearchRequest}, TContext> => {

const mutationKey = ['searchBySkillsApiConnectorsPersonsBySkillsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>, {data: SrcApiSchemasConnectorSchemasSkillSearchRequest}> = (props) => {
          const {data} = props ?? {};

          return  searchBySkillsApiConnectorsPersonsBySkillsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchBySkillsApiConnectorsPersonsBySkillsPostMutationResult = NonNullable<Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>>
    export type SearchBySkillsApiConnectorsPersonsBySkillsPostMutationBody = SrcApiSchemasConnectorSchemasSkillSearchRequest
    export type SearchBySkillsApiConnectorsPersonsBySkillsPostMutationError = HTTPValidationError

    /**
 * @summary Search by skills
 */
export const useSearchBySkillsApiConnectorsPersonsBySkillsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>, TError,{data: SrcApiSchemasConnectorSchemasSkillSearchRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchBySkillsApiConnectorsPersonsBySkillsPost>>,
        TError,
        {data: SrcApiSchemasConnectorSchemasSkillSearchRequest},
        TContext
      > => {

      const mutationOptions = getSearchBySkillsApiConnectorsPersonsBySkillsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get network of companies connected through people. Uses Neo4j for graph analysis.
 * @summary Get company network
 */
export const getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost = (
    srcApiSchemasConnectorSchemasCompanyNetworkRequest: SrcApiSchemasConnectorSchemasCompanyNetworkRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCompanyNetworkApiConnectorsPersonsCompanyNetworkPost200>(
      {url: `/api/connectors/persons/company-network`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: srcApiSchemasConnectorSchemasCompanyNetworkRequest, signal
    },
      );
    }
  


export const getGetCompanyNetworkApiConnectorsPersonsCompanyNetworkPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>, TError,{data: SrcApiSchemasConnectorSchemasCompanyNetworkRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>, TError,{data: SrcApiSchemasConnectorSchemasCompanyNetworkRequest}, TContext> => {

const mutationKey = ['getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>, {data: SrcApiSchemasConnectorSchemasCompanyNetworkRequest}> = (props) => {
          const {data} = props ?? {};

          return  getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCompanyNetworkApiConnectorsPersonsCompanyNetworkPostMutationResult = NonNullable<Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>>
    export type GetCompanyNetworkApiConnectorsPersonsCompanyNetworkPostMutationBody = SrcApiSchemasConnectorSchemasCompanyNetworkRequest
    export type GetCompanyNetworkApiConnectorsPersonsCompanyNetworkPostMutationError = HTTPValidationError

    /**
 * @summary Get company network
 */
export const useGetCompanyNetworkApiConnectorsPersonsCompanyNetworkPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>, TError,{data: SrcApiSchemasConnectorSchemasCompanyNetworkRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCompanyNetworkApiConnectorsPersonsCompanyNetworkPost>>,
        TError,
        {data: SrcApiSchemasConnectorSchemasCompanyNetworkRequest},
        TContext
      > => {

      const mutationOptions = getGetCompanyNetworkApiConnectorsPersonsCompanyNetworkPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get aggregations for analytics dashboards. Uses Elasticsearch for fast aggregations.
 * @summary Get analytics aggregations
 */
export const getAggregationsApiConnectorsPersonsAggregationsPost = (
    aggregationsRequest: AggregationsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AggregationsResponse>(
      {url: `/api/connectors/persons/aggregations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aggregationsRequest, signal
    },
      );
    }
  


export const getGetAggregationsApiConnectorsPersonsAggregationsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>, TError,{data: AggregationsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>, TError,{data: AggregationsRequest}, TContext> => {

const mutationKey = ['getAggregationsApiConnectorsPersonsAggregationsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>, {data: AggregationsRequest}> = (props) => {
          const {data} = props ?? {};

          return  getAggregationsApiConnectorsPersonsAggregationsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetAggregationsApiConnectorsPersonsAggregationsPostMutationResult = NonNullable<Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>>
    export type GetAggregationsApiConnectorsPersonsAggregationsPostMutationBody = AggregationsRequest
    export type GetAggregationsApiConnectorsPersonsAggregationsPostMutationError = HTTPValidationError

    /**
 * @summary Get analytics aggregations
 */
export const useGetAggregationsApiConnectorsPersonsAggregationsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>, TError,{data: AggregationsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAggregationsApiConnectorsPersonsAggregationsPost>>,
        TError,
        {data: AggregationsRequest},
        TContext
      > => {

      const mutationOptions = getGetAggregationsApiConnectorsPersonsAggregationsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List available jobs from Greenhouse.

Used by UI to populate job selection dropdown when configuring connector.
Fetches API key from stored connector configuration.

Args:
    connector_id: The Greenhouse connector ID
    department_id: Optional department ID to filter jobs by (includes subordinate departments)
 * @summary List Greenhouse Jobs
 */
export const listGreenhouseJobsApiConnectorsGreenhouseJobsGet = (
    params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListGreenhouseJobsApiConnectorsGreenhouseJobsGet200Item[]>(
      {url: `/api/connectors/greenhouse/jobs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryKey = (params?: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams,) => {
    return [
    `/api/connectors/greenhouse/jobs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryOptions = <TData = Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError = HTTPValidationError>(params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>> = ({ signal }) => listGreenhouseJobsApiConnectorsGreenhouseJobsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>>
export type ListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryError = HTTPValidationError


export function useListGreenhouseJobsApiConnectorsGreenhouseJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseJobsApiConnectorsGreenhouseJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseJobsApiConnectorsGreenhouseJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Greenhouse Jobs
 */

export function useListGreenhouseJobsApiConnectorsGreenhouseJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobsApiConnectorsGreenhouseJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobsApiConnectorsGreenhouseJobsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListGreenhouseJobsApiConnectorsGreenhouseJobsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List departments from Greenhouse with hierarchy information.

Returns departments with parent_id and child_ids for building a hierarchy tree.
Used by UI to populate department selection dropdown when configuring connector.
 * @summary List Greenhouse Departments
 */
export const listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet = (
    params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet200Item[]>(
      {url: `/api/connectors/greenhouse/departments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryKey = (params?: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams,) => {
    return [
    `/api/connectors/greenhouse/departments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryOptions = <TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError = HTTPValidationError>(params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>> = ({ signal }) => listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>>
export type ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryError = HTTPValidationError


export function useListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Greenhouse Departments
 */

export function useListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListGreenhouseDepartmentsApiConnectorsGreenhouseDepartmentsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List departments from Greenhouse with candidate counts.

Returns departments with the number of candidates who have applied to jobs
in each department. Includes:
- All candidates from currently OPEN jobs
- Candidates from CLOSED jobs that were closed within the lookback period

This helps users select departments with relevant, recent applicants while
excluding very old historical candidates (e.g., from jobs closed 3+ years ago).
 * @summary List Greenhouse Departments With Candidate Counts
 */
export const listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet = (
    params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet200Item[]>(
      {url: `/api/connectors/greenhouse/departments-with-counts`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryKey = (params?: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams,) => {
    return [
    `/api/connectors/greenhouse/departments-with-counts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryOptions = <TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError = HTTPValidationError>(params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>> = ({ signal }) => listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>>
export type ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryError = HTTPValidationError


export function useListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Greenhouse Departments With Candidate Counts
 */

export function useListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet<TData = Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListGreenhouseDepartmentsWithCandidateCountsApiConnectorsGreenhouseDepartmentsWithCountsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Test Greenhouse API connection before saving configuration.

Validates the API key by making a test API call.
Expects:
{
    "connector_type": "greenhouse",
    "credentials": {"api_key": "your_gh_api_key"},
    "sync_config": {}
}
 * @summary Test Greenhouse Connection
 */
export const testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost = (
    testConnectionRequest: TestConnectionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TestConnectionResponse>(
      {url: `/api/connectors/greenhouse/test-connection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testConnectionRequest, signal
    },
      );
    }
  


export const getTestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext> => {

const mutationKey = ['testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>, {data: TestConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPostMutationResult = NonNullable<Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>>
    export type TestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPostMutationBody = TestConnectionRequest
    export type TestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPostMutationError = HTTPValidationError

    /**
 * @summary Test Greenhouse Connection
 */
export const useTestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>, TError,{data: TestConnectionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPost>>,
        TError,
        {data: TestConnectionRequest},
        TContext
      > => {

      const mutationOptions = getTestGreenhouseConnectionApiConnectorsGreenhouseTestConnectionPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test a Greenhouse query configuration to see how many candidates match.

This allows users to preview their query results before running a full analysis.

Request body:
{
    "connector_id": "greenhouse_eliza_abc123",
    "query_params": {
        "job_ids": "123,456",  # Optional
        "application_status": "active",  # Optional: active, rejected, hired
        "created_after": "2024-01-01",  # Optional: ISO date
        "max_candidates": 50  # Optional: 1-1000
    }
}

Response:
{
    "success": true,
    "job_count": 5,
    "candidate_count": 127,
    "message": "Found 127 candidates across 5 jobs"
}
 * @summary Test Greenhouse Query
 */
export const testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost = (
    testGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPost200>(
      {url: `/api/connectors/greenhouse/test-query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody, signal
    },
      );
    }
  


export const getTestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>, TError,{data: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>, TError,{data: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody}, TContext> => {

const mutationKey = ['testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>, {data: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody}> = (props) => {
          const {data} = props ?? {};

          return  testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostMutationResult = NonNullable<Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>>
    export type TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostMutationBody = TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody
    export type TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostMutationError = HTTPValidationError

    /**
 * @summary Test Greenhouse Query
 */
export const useTestGreenhouseQueryApiConnectorsGreenhouseTestQueryPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>, TError,{data: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testGreenhouseQueryApiConnectorsGreenhouseTestQueryPost>>,
        TError,
        {data: TestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostBody},
        TContext
      > => {

      const mutationOptions = getTestGreenhouseQueryApiConnectorsGreenhouseTestQueryPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Submit a market candidate to a Greenhouse job posting.

This uses the Job Board API (not Harvest API) to submit external candidates
as applicants to specific job postings.

Request body:
{
    "connector_id": "greenhouse_job_board_abc123",
    "job_id": 123456,
    "candidate": {
        "first_name": "John",
        "last_name": "Doe",
        "email": "john@example.com",
        "phone": "+1-555-0100",
        "location": "San Francisco, CA",
        "linkedin_url": "https://linkedin.com/in/johndoe",
        "resume_url": "https://...",  # Optional: URL to fetch resume
        "resume_bytes": "base64...",   # Optional: Base64 encoded resume
        "resume_filename": "john_doe_resume.pdf",
        "cover_letter": "I am excited to apply..."
    }
}

Response:
{
    "success": true,
    "application_id": "app_abc123",
    "message": "Candidate submitted successfully",
    "job_title": "Senior Software Engineer"
}
 * @summary Submit Candidate To Greenhouse
 */
export const submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost = (
    submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost200>(
      {url: `/api/connectors/greenhouse/submit-candidate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody, signal
    },
      );
    }
  


export const getSubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>, TError,{data: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>, TError,{data: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody}, TContext> => {

const mutationKey = ['submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>, {data: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody}> = (props) => {
          const {data} = props ?? {};

          return  submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostMutationResult = NonNullable<Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>>
    export type SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostMutationBody = SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody
    export type SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostMutationError = HTTPValidationError

    /**
 * @summary Submit Candidate To Greenhouse
 */
export const useSubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>, TError,{data: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePost>>,
        TError,
        {data: SubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostBody},
        TContext
      > => {

      const mutationOptions = getSubmitCandidateToGreenhouseApiConnectorsGreenhouseSubmitCandidatePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List all active job postings from Greenhouse Job Board.

This endpoint is used to populate the job dropdown when submitting candidates.
Returns jobs with searchable titles and IDs.
 * @summary List Greenhouse Job Board Jobs
 */
export const listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet = (
    params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet200Item[]>(
      {url: `/api/connectors/greenhouse/job-board/jobs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryKey = (params?: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams,) => {
    return [
    `/api/connectors/greenhouse/job-board/jobs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryOptions = <TData = Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError = HTTPValidationError>(params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>> = ({ signal }) => listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>>
export type ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryError = HTTPValidationError


export function useListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Greenhouse Job Board Jobs
 */

export function useListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet<TData = Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError = HTTPValidationError>(
 params: ListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListGreenhouseJobBoardJobsApiConnectorsGreenhouseJobBoardJobsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



